import { useNews } from "../../hooks/NewsHooks";
import NewsGrid from "../NewsGrid";
import { Link } from "react-router-dom";
import useWindowSize from "../../hooks/useWindowSize";
import { useBjelinTranslations } from "../../hooks/TranslationHooks";
import Icon from "../Icon";
import { News } from "../../types/News";
import { Suspense } from "react";
import { Spinner } from "reactstrap";

const NewsGridMenuContent = () => {
  const t = useBjelinTranslations();
  const winDim = useWindowSize();
  const news: News = useNews(winDim.innerWidth > 992 ? 3 : 2);

  return news.length > 0 ? (
    <div>
      <h3>
        <Link to="/news">
          <span className="title black-on-hover">{t("news")}</span>
          <span className="more">
            {t("more")}{" "}
            <Icon name="chevron-right" type="fal" className="ms-1" />
          </span>
        </Link>
      </h3>
      <NewsGrid news={news} compact />
    </div>
  ) : null;
};

const NewsGridMenu = () => {
  return (
    <Suspense fallback={<Spinner />}>
      <NewsGridMenuContent />
    </Suspense>
  );
};

export default NewsGridMenu;
